angular.module('moebiusProadapt').controller('ctrlEtudeDetailParticipant',
    ['$window','$scope', '$rootScope', '$http', '$location', '$uibModal', '$anchorScroll', '$timeout', 'promiseTracker', 'mbsEtiService', 'mbsParticipantService', 'eti_configuration', 'detailParticipantResolver', 'visiteKey', function ($window, $scope, $rootScope, $http, $location, $uibModal, $anchorScroll, $timeout, promiseTracker, mbsEtiService, mbsParticipantService, eti_configuration, detailParticipantResolver, visiteKey) {

        $timeout(function() {
            $scope.pageIsLoaded = false;
        });

        if($rootScope.globalParams.showDebug) {
            // console.log(participantResolver);
            console.log(eti_configuration);
            console.log('Current Eti ' + mbsEtiService.getCurrentEti().id);
            console.log('Current Eti ' + $scope.eti.id);
        }

        $scope.onglet  = null;

        $scope.interface = {
            ongletsOrderedIdsForParticipant: null,
            ongletsCount: null,
            questionnaireKey: null
        };

        $scope.dateOptions = {
            datepickerMode: 'year',
            maxDate: new Date(),
            yearRows: 6,
            yearColumns: 6
        };

        $scope.selectOnglet = function(ongletId) {

            // -- save all QV unsaved of all QRV of this onglet
//            mbsParticipantService.getCurrentParticipant().saveQuestionnaireVisite(_scope.questionnaireVisite.key);
            console.log('ONGLET !!!! ' , $scope.onglet);
            var allQvIdsOfLeavingOnglet = [];
            mbsEtiService.getCurrentVisite().getQuestionnairesVisitesForOnglet($scope.onglet).forEach(function(qrv) {
                if (qrv.questionsVisitesOrderedIds) {
                    qrv.questionsVisitesOrderedIds.forEach(function(qvId) {
                        // -- on retient toutes les questions non saved
                        if (mbsEtiService.getCurrentEti().etudedefArray.questionsVisitesList[qvId].isDirty) {
                            allQvIdsOfLeavingOnglet.push(qvId);
                        }
                    });
                }
            });

            if (allQvIdsOfLeavingOnglet.length > 0) {
                // -- @todo, validate
                mbsParticipantService.getCurrentParticipant().saveQuestionsVisites(allQvIdsOfLeavingOnglet).then(function(response) {
                    mbsEtiService.getCurrentVisite().getQuestionnairesVisitesForOnglet($scope.onglet).forEach(function(qrv) {
                        mbsEtiService.getCurrentEti().etudedefArray.questionnairesVisitesList[qrv.key].updateProgress(mbsParticipantService.getCurrentParticipant());
                        mbsEtiService.getCurrentEti().etudedefArray.questionnairesVisitesList[qrv.key].isDirty = false;
                    });
                    // -- changement d'onglet
                    $scope.onglet = $scope.eti.etudedefArray.ongletsList[ongletId];
                });
            } else {
                // -- changement d'onglet
                $scope.onglet = $scope.eti.etudedefArray.ongletsList[ongletId];
            }

            //scrollTop
            document.getElementById('scroll-container').scrollTop=0;


        };
        $scope.gotoAnchorQuestionnaire = function(x) {
            throw('deprecated call to $scope.gotoAnchorQuestionnaire ');

            var newHash = 'anchor' + x;
            $anchorScroll(newHash);
            $scope.interface.questionnaireKey = x;
        };

        /**
         * *************************************************************************************************
         * ********************* DATA and ROUTE
         * *************************************************************************************************
         */

        $scope.doMapDataEtiConfiguration = function (eti_configuration_object) {


            //// -- do it only when we change of ETI or has been updated
            if ((mbsEtiService.getCurrentEti().id !== eti_configuration_object.eti.id) || (mbsEtiService.getCurrentEti().updated_at != eti_configuration_object.eti.updated_at)) {
                console.log('doMapDataEtiConfiguration');
                mbsEtiService.initWithEti(eti_configuration_object.eti);
            }
            // -- si on a l'ETI en cache, mais qu'on passe par ce hook, alors il faut réinit les calculs dans les objets enrichis
            else if (mbsEtiService.getCurrentEti().id === eti_configuration_object.eti.id) {
                mbsEtiService.reinitData();
            }
            mbsEtiService.setCurrentVisite($rootScope.eti.etudedefArray.visitesList[visiteKey]);
            $scope.onglet                 = $rootScope.eti.etudedefArray.ongletsList[$rootScope.visite.ongletsOrderedIds[0]];

            // -- 210201_15 Visibilité des onglets conditonnel selon participant
            $scope.interface.ongletsOrderedIdsForParticipant = _.filter($rootScope.visite.ongletsOrderedIds, function (ongletId) {
                // -- current evaluated onglet
                var onglet = $rootScope.eti.etudedefArray.ongletsList[ongletId];

                // -- @todo REMOVE THIS ONCE WE LAUNCH JALON2
                //  @todo : TANT QUE Jalon2 n'est pas en prod, on exclus paroucs de soin en dûr
                if ( ! $rootScope.globalParams.moebiusMode && onglet.name === 'Parcours de soin') {
                    return false;
                }


                if (
                    $scope.participant.is_optimized
                    && [
                        $rootScope.constants.available_for_participant.NAMES_TO_VALUES.optimized,
                        $rootScope.constants.available_for_participant.NAMES_TO_VALUES.both
                    ].indexOf(onglet.available_for_participant) !== -1
                ) {

                        return true;

                } else if (
                    !$scope.participant.is_optimized // NOT OPTMIZED
                    && [
                        $rootScope.constants.available_for_participant.NAMES_TO_VALUES.not_optimized,
                        $rootScope.constants.available_for_participant.NAMES_TO_VALUES.both
                    ].indexOf(onglet.available_for_participant) !== -1
                ) {

                        return true;

                } else {

                        return false;
                }
            });
            $scope.interface.ongletsCount = $scope.interface.ongletsOrderedIdsForParticipant.length;
        };

        /**
         * *************************************************************************************************
         * ********************* ADMIN ACTION
         * *************************************************************************************************
         */

        /**
         * *************************************************************************************************
         * ********************* ACTIONS
         * *************************************************************************************************
         */

        /**
         * Réceptionne les clics sur les boutons de status
         */
        $scope.onClickStatusButton = function(participant, status) {
            /*console.log('participant', participant);
            console.log('status', status);*/

            var thisParticipantVisite = $scope.getParticipantVisite();
            if (thisParticipantVisite.date_submitted) {
                return;
            }

            var promise;

            switch (status) {

            case $rootScope.constants.visite_status.NAMES_TO_VALUES.SS__START_RDV_PHYSIQUE:

                // --
                // -- Affichage de la modal de dateVisite QUE si cette date visite n'est pas encore enregistrée !

                var qvDateDeLaVisite = $scope.visite.getQuestionVisiteForQuestionMereKeyShort('QM__DATE_DE_LA_VISITE');
                // -- si la date est déjà settée ET enregistrée
                if ($scope.participant.getValue(qvDateDeLaVisite)
                    && $scope.participant.getValue(qvDateDeLaVisite) instanceof Date
                    && qvDateDeLaVisite.isDirty === false
                ) {
                    var payloadWithDate = {
                        dateValue: $scope.participant.getValue(qvDateDeLaVisite)
                    };
                    // -- si la date de visite est déjà enregistrée, on save juste le status sans ouvrir de modale
                    promise = $scope.saveVisiteStatus(status, payloadWithDate);
                } else {
                    // -- open modal date Visite only si elle n'est pas encore enregistrée
                    promise = $scope.openModalStartVisite();
                }

                break;

            case $rootScope.constants.visite_status.NAMES_TO_VALUES.SS__END_RDV_PHYSIQUE:

                promise = $scope.saveVisiteStatus(status, {});
                break;
            case $rootScope.constants.visite_status.NAMES_TO_VALUES.SS__START_QR_MOBILE:
                // -- @todo, handle remote activation of QR on tablette
                promise = $scope.saveVisiteStatus(status, {});
                break;
            case $rootScope.constants.visite_status.NAMES_TO_VALUES.SS__END_QR_MOBILE:
                // -- @todo, handle remote querying of a QR on tablette
                promise =  $scope.saveVisiteStatus(status, {});
                break;
            case $rootScope.constants.visite_status.NAMES_TO_VALUES.SS__OPENED:
                promise =  $scope.saveVisiteStatus(status, {});
                break;
            case $rootScope.constants.visite_status.NAMES_TO_VALUES.SS__FINAL_APPROVED:
                promise = $scope.saveVisiteStatus(status, {});
                break;
            case $rootScope.constants.visite_status.NAMES_TO_VALUES.SS__REJECTED:
                promise = $scope.saveVisiteStatus(status, {});
                break;
            case $rootScope.constants.visite_status.NAMES_TO_VALUES.SS__NOT_APPLICABLE:
                promise = $scope.saveVisiteStatus(status, {});
                break;
            default:
                break;
            }

            $rootScope.participantTracker.addPromise(promise);

            return promise;

        };

        $scope.jumpToVF = function(participant) {
            if( ! confirm('Etes-vous sûr de vouloir passer directement à la VF ? Cette action sera considéré comme une sortie de l\'étude prématurée, vous pourrez renseigner ces raisons là dans la VF')) {
                return;
            }
            var promise = $scope.onClickStatusButton(participant, $rootScope.constants.visite_status.NAMES_TO_VALUES.SS__NOT_APPLICABLE);
            promise.then(function() {
                var lastVisiteKey = mbsEtiService.getCurrentEti().etudedefArray.visitesOrderedKeys[mbsEtiService.getCurrentEti().etudedefArray.visitesOrderedKeys.length -1];
                $scope.submitParticipant(lastVisiteKey);
            });
        };

        $scope.shouldDisplayJumpToVF = function(participant) {
            var status = $scope.getParticipantVisite().status;
            var isVisiteHavingATransitionJump = mbsEtiService.getCurrentEti().etudedefArray.statusTransitionList[$scope.visite.key][$rootScope.constants.visite_status.NAMES_TO_VALUES.SS__NOT_APPLICABLE];
            var isStatusAllowJump = [$rootScope.constants.visite_status.NAMES_TO_VALUES.SS__REJECTED].indexOf(status) === -1;
            return isVisiteHavingATransitionJump && isStatusAllowJump;
        };

        $scope.openModalDeclareDeath = function (participant) {

            var scopeModal = $scope.$new();

            //Create modal instance
            var modalInstance = $uibModal.open({
                templateUrl: 'assets/templates/generic_templates/modal-declare-death.html',
                windowClass: 'md-dialog',
                scope: scopeModal
            });

            var promise = modalInstance.result;

            promise.then(function (paramModal) {

                if (paramModal) {
                    var payload = {
                        participant_id: $scope.participant.id,
                        date_deces: paramModal.date_deces,
                        cause_deces: paramModal.cause_deces
                    };

                    var promiseHttp =  $http.post('etude-instance/declare-participant-death', payload)
                        .then(function(responseObject) {
                            $scope.onClickStatusButton(participant, $scope.constants.visite_status.NAMES_TO_VALUES.SS__REJECTED);
                        });

                    $rootScope.participantTracker.addPromise(promiseHttp);
                }
            });

        };

        /**
         * modal de démarrage de la visite
         */
        $scope.openModalStartVisite = function () {

            var pDateValue = new Date();
            if ($scope.participant.getValue($scope.visite.getQuestionVisiteForQuestionMereKeyShort('QM__DATE_DE_LA_VISITE'))
                && $scope.participant.getValue($scope.visite.getQuestionVisiteForQuestionMereKeyShort('QM__DATE_DE_LA_VISITE')) instanceof Date
            ) {
                pDateValue = $scope.participant.getValue($scope.visite.getQuestionVisiteForQuestionMereKeyShort('QM__DATE_DE_LA_VISITE'));
            }

            var scopeModal = $scope.$new();
            scopeModal.paramModal = {
                dateValue: pDateValue
            };

            scopeModal.saveDateVisite = function() {
                // -- comme c'est fait, la modale est backdrop et ne peut être quittée sans résultat
                var modifiedQv = [];

                var paramModal = this.paramModal;

                if (paramModal) {

                    paramModal.dateValue.setHours(12,0,0,0);

                    var payload = {
                        dateValue: paramModal.dateValue
                    };
                    var promiseHttp =  $scope.saveVisiteStatus($scope.constants.visite_status.NAMES_TO_VALUES.SS__START_RDV_PHYSIQUE, payload);

                    $rootScope.participantTracker.addPromise(promiseHttp);
                }

                this.$close(modifiedQv);
            };

            //Create modal instance
            var modalInstance = $uibModal.open({
                templateUrl: 'assets/templates/generic_templates/modal-start-visite.html',
                windowClass: 'md-dialog',
                scope: scopeModal,
                controller: function ($scope, $document) {

                    var EVENT_TYPES = "keydown keypress"
                    function eventHandler(event) {
                        if (event.which === 13) {
                            // -- champs obligatoire
                            if (!$scope.paramModal.dateValue) {
                                return;
                            }
                            else {
                                $scope.saveDateVisite();
                            }
                        }
                    }
                    $document.bind(EVENT_TYPES, eventHandler);
                    $scope.$on('$destroy', function () {
                        $document.unbind(EVENT_TYPES, eventHandler);
                    })
                }
            });

            var promise = modalInstance.result;


            return promise;

        };

        /**
         * @private
         */
        $scope.saveVisiteStatus = function(visiteStatus, payload)
        {
            console.log('saveVisiteStatus');
            // var currentStep = $scope.participant.participantVisitesByVisiteKey[visiteKey];

            var promise = $http.post('etude-instance/save-visite-status/' + mbsEtiService.getCurrentEti().id + '/' + $scope.visite.key + '/' + $scope.participant.id + '/' + visiteStatus, payload);

            $rootScope.participantTracker.addPromise(promise);

            promise.then(function(responseObject)
            {
                // -- Transform Participant Object
                mbsParticipantService.statelessTransformParticipantHeader(responseObject.data.participant);

                // -- 210216 YG - normalement on a pas besoin de cette étape car nousn faisons un mergeData dans callbackSaveQuestionsVisites, plus loin
                // -- 210216 YG - de plus, depuis l'ajout des méthode getValue et setValue sur le participant, cette méthode là ne travaille qu'avec un
                // -- 210216 YG - un objet participant possédant en plus ces méthodes
                //  mbsParticipantService.statelessTransformParticipantValues(responseObject.data.participant);


                // -- 210216 YG - @todo BUG non résolu en isDirectSaveMode = false
                // -- 210216 YG - @todo ------------------
                // -- 210216 YG - @todo ATTENTION, CE BUG était vrai avant la branche 210205_23_YG
                // -- 210216 YG - @todo ------------------
                // -- @todo : quand on saveStatusVisite, les QV manuelle en dirty sont remis (même sans appeller statelessTransformParticipantValues) MAIS
                //  les QV auto non saved, e.g. IMC,  sont vidés !!!
                //  la dateVisite est vidée si elle était dirty ET qu'on est sur une transistion qui ne la sauvegarde PAS

                // // -- on s'assure que la date de démarrage de la visite est bien une date
                var qvToUpdateIds = [];
                var qvDate = $scope.visite.getQuestionVisiteForQuestionMereKeyShort('QM__DATE_DE_LA_VISITE');
                if (qvDate) {
                    qvToUpdateIds.push(qvDate.id)
                }
                mbsParticipantService.getCurrentParticipant().callbackSaveQuestionsVisites(responseObject, qvToUpdateIds);

                // automatically refresh data in ui-grid
                mbsParticipantService.initWithParticipant(responseObject.data.participant);

            });

            return promise;
        };

        $scope.submitParticipant = function(targetVisiteKeyIfBranchingTransition) {

            var urlBatchSubmit = 'etude-instance/batch-submit-visite/' + mbsEtiService.getCurrentEti().id + '/' + $scope.visite.key;

            if (targetVisiteKeyIfBranchingTransition) {
                urlBatchSubmit += '/' + targetVisiteKeyIfBranchingTransition;
            }

            var promise = $http.post(urlBatchSubmit, {
                ids:  [$scope.participant.id]
            }).then(function() {
                if (targetVisiteKeyIfBranchingTransition) {
                    $location.path('/etude/' + mbsEtiService.getCurrentEti().id +'/participant/'+$scope.participant.id+'/'+targetVisiteKeyIfBranchingTransition);
                }
                else {
                    $location.path('/etude/' + mbsEtiService.getCurrentEti().id +'');
                }
            });
            $rootScope.participantTracker.addPromise(promise);
        };


        /**
         * @param Participant participant
         * @param String    visiteKey
         */
        $scope.getParticipantVisite = function()
        {
            var visiteKey = $scope.visite.key;
            if($scope.participant.participantVisitesByVisiteKey && $scope.participant.participantVisitesByVisiteKey[visiteKey]) {
                return $scope.participant.participantVisitesByVisiteKey[visiteKey];
            }
            else {
                return null;
            }
        };

        $scope.lockParticipant = function(participantId)
        {
            var promise = $http.get("lockParticipant/" + participantId).then(function(data) {
                $window.location.reload();
                // $location.reload();//('/etude/' + mbsEtiService.getCurrentEti().id +'/participant/'+$scope.participant.id+'/'+$scope.getParticipantVisite().visite_key);
            });
            $rootScope.participantTracker.addPromise(promise);
        };


        $scope.openModalMandatoryForSubmit = function () {


            //Create modal instance
            var modalInstance = $uibModal.open({
                templateUrl: 'assets/templates/generic_templates/modal/mandatory-for-submit.html',
                // controller: 'ctrlEtudeAddParticipant',
                windowClass: 'md-dialog',
                scope: $scope,
                backdrop: 'static'
            });

            var promise = modalInstance.result;

        };

        //confirm before leaving if data not saved
        $scope.$on('$locationChangeStart', function( event, next ) {
            var allQvIdsOfLeavingOnglet = [];
            mbsEtiService.getCurrentVisite().getQuestionnairesVisitesForOnglet($scope.onglet).forEach(function(qrv) {
                if (qrv.questionsVisitesOrderedIds) {
                    qrv.questionsVisitesOrderedIds.forEach(function(qvId) {
                        // -- on retient toutes les questions non saved
                        if (mbsEtiService.getCurrentEti().etudedefArray.questionsVisitesList[qvId].isDirty) {
                            allQvIdsOfLeavingOnglet.push(qvId);
                        }
                    });
                }
            });

            if (allQvIdsOfLeavingOnglet.length > 0) {
                var answer = confirm("Certaines données n'ont pas encore été sauvegardées, voulez vous les sauvegarder maintenant?")
                if (answer) {
                    // -- @todo, validate
                    mbsParticipantService.getCurrentParticipant().saveQuestionsVisites(allQvIdsOfLeavingOnglet).then(function(response) {
                        mbsEtiService.getCurrentVisite().getQuestionnairesVisitesForOnglet($scope.onglet).forEach(function(qrv) {
                            mbsEtiService.getCurrentEti().etudedefArray.questionnairesVisitesList[qrv.key].updateProgress(mbsParticipantService.getCurrentParticipant());
                            mbsEtiService.getCurrentEti().etudedefArray.questionnairesVisitesList[qrv.key].isDirty = false;
                        });
                    });
                }
            }
        });

        /**
         * *************************************************************************************************
         * ********************* Initialization
         * *************************************************************************************************
         */

        /**
         * setup the controller
         */
        var initialize = function () {
            // -- setup data from resolver
            $scope.doMapDataEtiConfiguration(eti_configuration);

            // -- ------------------
            // -- Transform Participant Object
            // -- ------------------
            mbsParticipantService.statelessTransformParticipantHeader($scope.participant);

            mbsParticipantService.statelessTransformParticipantValues($scope.participant);

            if ($scope.getParticipantVisite() && $scope.getParticipantVisite().status === 0) {
                // $scope.openModalStartVisite();
            }

        };
        console.log('ctrlEtudeIndex bootstrap');
        initialize();
        $timeout(function() {
            $scope.pageIsLoaded = true;
        },100);

    }
    ]
);



// WEBPACK FOOTER //
// ./resources/assets/js/controllers/etude/etudeDetailParticipant.js